<template>
    <div class="float-left mr-1" v-if="permiteExibirAprovadores">
        <span class="text-primary">
            <i
                class="fa fa-user fa-lg icon-button"
                title="Aprovadores"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal" @show="preencherForm()">
            <div slot="modal-title">
                Serviço {{ comprometimento.idComprometimento }} - Aprovadores
            </div>
            <h6 class="heading-1">
                <span>APROVADOR</span>
            </h6>
            <span
                >Nome: <strong>{{ aprovadores.nomeAprovador }}</strong></span
            ><br />
            <span
                >Email: <strong>{{ aprovadores.emailAprovador }}</strong></span
            ><br />

            <div v-if="aprovadores.codAprovadorDesignado" class="mt-2">
                <h6 class="heading-1">
                    <span>APROVADOR DESIGNADO</span>
                </h6>

                <span
                    >Nome:
                    <strong>{{
                        aprovadores.nomeAprovadorDesignado
                    }}</strong></span
                ><br />
                <span
                    >Email:
                    <strong>{{
                        aprovadores.emailAprovadorDesignado
                    }}</strong></span
                >
            </div>
            <div v-if="permiteDesignarAprovador" class="mt-2">
                <h6 class="heading-1">
                    <span>DESIGNAR APROVADOR</span>
                </h6>
                <model-list-select
                    :list="aprovadoresDisponiveis"
                    option-text="codNomeFuncionario"
                    option-value="codFuncionario"
                    v-model="codAprovadorDesignado"
                >
                </model-list-select>
            </div>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fechar()"
                    class="mr-2"
                    >Fechar</b-button
                >
                <b-button
                    :disabled="!codAprovadorDesignado"
                    v-if="permiteDesignarAprovador"
                    variant="primary"
                    @click.stop="confirmarDesignacaoAprovador()"
                    class="mr-2"
                    ><i class="fa fa-user-plus"></i> Designar
                    Aprovador</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { comprometimentoStatus } from './ComprometimentoStatus'
import { ModelListSelect } from 'vue-search-select'

export default {
    components: {
        ModelListSelect
    },

    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        },

        dataServico: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            aprovadores: {},
            aprovadoresDisponiveis: [],
            codAprovadorDesignado: null
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fechar() {
            this.aprovadoresDisponiveis = []
            this.codAprovadorDesignado = null
            this.mostrarModal = false
        },

        preencherForm() {
            this.obterAprovadores()
            if (this.permiteDesignarAprovador) {
                this.obterAprovadoresDisponiveis()
            }
        },

        obterAprovadores() {
            this.$store.dispatch('addRequest')
            this.dataServico
                .obterComprometimentoAprovadores(
                    this.comprometimento.idComprometimento
                )
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.aprovadores = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter aprovadores!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        obterAprovadoresDisponiveis() {
            this.$store.dispatch('addRequest')
            this.dataServico
                .obterComprometimentoAprovadoresDisponiveis(
                    this.comprometimento.idComprometimento
                )
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.aprovadoresDisponiveis = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter aprovadores disponíveis!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        confirmarDesignacaoAprovador() {
            this.$swal({
                title: 'Designação de Aprovdor',
                html: `Confirma o designação de <b>${this.aprovadorDesignado.codNomeFuncionario}</b> para aprovação do serviço <b>${this.comprometimento.idComprometimento}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.designarAprovador()
                }
            })
        },

        designarAprovador() {
            this.$store.dispatch('addRequest')
            let aprovador = {
                idComprometimento: this.comprometimento.idComprometimento,
                codAprovador: this.codAprovadorDesignado
            }
            this.dataServico
                .designarComprometimentoAprovador(aprovador)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Designação realizada com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.obterAprovadores()
                            this.codAprovadorDesignado = null
                        } else {
                            this.$toast.error(
                                'Erro ao designar aprovador.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {},

    computed: {
        permiteExibirAprovadores() {
            return (
                this.comprometimento.status ==
                    comprometimentoStatus.EM_ANALISE ||
                this.comprometimento.status == comprometimentoStatus.APROVADO ||
                this.comprometimento.status == comprometimentoStatus.REPROVADO
            )
        },

        permiteDesignarAprovador() {
            return (
                this.comprometimento.status ==
                    comprometimentoStatus.EM_ANALISE &&
                this.$temAcessoView('CONT-COMPR-13')
            )
        },

        aprovadorDesignado() {
            return this.aprovadoresDisponiveis.find(
                p => p.codFuncionario === this.codAprovadorDesignado
            )
        }
    },

    validations: {}
}
</script>
